import { render, staticRenderFns } from "./PurchaseAccount.vue?vue&type=template&id=18fc7954&scoped=true"
import script from "./PurchaseAccount.vue?vue&type=script&lang=js"
export * from "./PurchaseAccount.vue?vue&type=script&lang=js"
import style0 from "./PurchaseAccount.vue?vue&type=style&index=0&id=18fc7954&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fc7954",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18fc7954')) {
      api.createRecord('18fc7954', component.options)
    } else {
      api.reload('18fc7954', component.options)
    }
    module.hot.accept("./PurchaseAccount.vue?vue&type=template&id=18fc7954&scoped=true", function () {
      api.rerender('18fc7954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/userDetails/components/PurchaseAccount.vue"
export default component.exports